import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { GitBranch } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { FlowNode, NodeVisualDefinition } from '../../types';

import { ConditionConfigType, getConditionPreviewText } from './schema';

/** Typed node for condition */
type ConditionNodeType = FlowNode<ConditionConfigType>;

/** Visual definition for the Condition node */
export const conditionVisualDefinition: NodeVisualDefinition = {
  key: 'Condition',
  label: 'Condition',
  description: 'Branch flow based on a condition',
  icon: GitBranch,
  color: 'purple',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      id: 'true',
      className: 'left-[25%]! bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      id: 'false',
      className: 'left-[75%]! bg-gray!',
    },
  ],
  getContent: getConditionPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Condition nodes on the canvas.
 * Uses BaseNode with dual source handles for true/false branches.
 */
export const ConditionNode = React.memo<NodeProps<ConditionNodeType>>(
  (props) => (
    <BaseNode
      {...props}
      definition={conditionVisualDefinition}
      className="@ConditionNode"
    />
  ),
);

ConditionNode.displayName = 'ConditionNode';
